module.exports = __webpack_public_path__ + "img/appLogo.aa5ce2d9.svg";